import React, { ReactElement, useState, useContext, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { useLocation } from "react-router";
import { useNavigate } from "react-router";
import { ApiService } from "../../../services/api.service";
import Loader from "../../Loader";
import AdminHeader from "../shared/header";
import AdminNav from "../shared/nav";
import { SearchContext } from "../../../context/searchContext";
import { border } from "@cloudinary/url-gen/qualifiers/background";

function Customers(): ReactElement {
  const location = useLocation();

  if (location.pathname.includes("Administration")) {
    var el = document.getElementById("MAheader");
    if (el !== null) {
      el.style.display = "none";
    }
  }

  const {
    searchText,
    setSearchText,
    searchData,
    setSearchData,
    searchType,
    setSearchType,
  } = useContext(SearchContext);

  const [loading, setLoading] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");

  const [customers, setCustomers] = useState([]);

  const navigate = useNavigate();

  function handleClick(item: any) {
    navigate("/Administration/CustomerEdit?id=" + item);
  }

  const handleSearch = () => {
    if (searchKeyword.trim().length >= 3) {
      setLoading(true);
      setCustomers([]); // Clear old results
      setSearchText(searchKeyword);
      setSearchType("Customers");

      const apiService = new ApiService();
      const fetchCustomers = async () => {
        const response = await apiService.getCustomerByKeyword(searchKeyword);
        setCustomers(response);
        setSearchData(response);
        setLoading(false);
      };

      fetchCustomers();
    }
  };

  useEffect(() => {
    // Restore customer list only if none are currently loaded
    if (
      customers.length === 0 &&
      searchType === "Customers" &&
      searchData?.length > 0
    ) {
      setCustomers(searchData);
    }
  }, []);

  return (
    <div>
      <AdminHeader></AdminHeader>

      <div className="container-fluid">
        <div className="row">
          <AdminNav></AdminNav>
          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
              <h1 className="h2">Customers</h1>
              {/* <div className="btn-toolbar mb-2 mb-md-0">
                <div className="btn-group me-2">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                  >
                    Share
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                  >
                    Export
                  </button>
                </div>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary dropdown-toggle"
                >
                  <span
                    data-feather="calendar"
                    className="align-text-bottom"
                  ></span>
                  This week
                </button>
              </div> */}
            </div>

            <Form>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Customer Search</Form.Label>
                <div style={{ display: "flex", gap: "8px" }}>
                  <Form.Control
                    type="text"
                    placeholder="Enter customer or address data"
                    style={{
                      textAlign: "left",
                      marginBottom: "0px",
                    }}
                    value={searchKeyword}
                    onChange={(e) => setSearchKeyword(e.target.value)}
                  />
                  <Button
                    variant="primary"
                    onClick={handleSearch}
                    disabled={searchKeyword.trim().length < 3}
                  >
                    Search
                  </Button>
                </div>
              </Form.Group>
            </Form>

            {loading ? (
              <Loader />
            ) : (
              <div className="table-responsive">
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Ref</th>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Address</th>
                      <th scope="col">Mailing</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody style={{ border: "1px solid #ddd" }}>
                    {customers &&
                      customers.map((item: any) => (
                        <React.Fragment key={item.userGuid}>
                          {/* Customer row */}
                          <tr
                            style={{
                              cursor: "pointer",
                              marginBottom: 10,
                              backgroundColor: "#eee",
                            }}
                            onClick={() => handleClick(item.userGuid)}
                          >
                            <td style={{ width: "5%" }}>{item.userID}</td>
                            <td>
                              {item.userFirstname} {item.userSurname}
                            </td>
                            <td>{item.userEmail}</td>
                            <td>
                              {item.userHouseNo} {item.userStreet}{" "}
                              {item.userPostcode} {item.userCounty}{" "}
                              {item.userCity}
                            </td>
                            <td>{item.userSubscribe}</td>
                            <td>{item.userStatus}</td>
                          </tr>

                          {/* One <tr> per delivery address */}
                          {item.deliveryAddresses &&
                            item.deliveryAddresses.map(
                              (addr: any, index: number) => (
                                <tr
                                  style={{ backgroundColor: "#fff" }}
                                  key={`${item.userGuid}-addr-${index}`}
                                >
                                  <td></td>
                                  <td
                                    colSpan={5}
                                    style={{
                                      paddingLeft: "2rem",
                                      fontStyle: "italic",
                                      fontWeight: "bold",
                                      fontSize: 12,
                                    }}
                                  >
                                    {addr.deliveryBuildingNo}{" "}
                                    {addr.deliveryStreet} {addr.deliveryRegion}{" "}
                                    {addr.deliveryPostalcode}
                                  </td>
                                </tr>
                              )
                            )}
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
              </div>
            )}
          </main>
        </div>
      </div>
    </div>
  );
}

export default Customers;
